import TabOrderInspections from './TabOrderInspections';

export default TabOrderInspections;
